import React from "react";
import { Image } from "react-bootstrap";

export const TopTextReusableComponent = ({
  headingText,
  headingParagraph,
  displayEdit,
  onClickEdit,
}) => {
  return (
    <React.Fragment>
      <div className="top-text-reusable-heading mt-2 mb-2">
        <div className="d-flex justify-content-between">
          <div className="f24_700_HelveticaNeue" style={{paddingBottom:5}}>{headingText}</div>
          {displayEdit === true ? (
            <div
              style={{ cursor: "pointer", width: "4%" }}
              className="text-right"
            >
              <Image
                fluid
                src={require("../../../../assets/images/AuthImages/editBigRed.svg")}
                alt="Edit"
                title="Edit"
                onClick={onClickEdit}
              />
            </div>
          ) : null || displayEdit === false ? (
            <div
              style={{ cursor: "pointer", width: "4%" }}
              className="text-right"
            >
              <Image
                fluid
                src={require("../../../../assets/images/AuthImages/editBigBlack.svg")}
                alt="Edit"
                title="Edit"
                onClick={onClickEdit}
              />
            </div>
          ) : null}
        </div>
        {/* <hr className="bottom-hr" /> */}
        <div className="f12-400 opacity5">{headingParagraph}</div>
      </div>
    </React.Fragment>
  );
};
